/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { HelpLink } from '@bingads-webui-react/help-link';
import { Dropdown } from '@bingads-webui-react/fabric-control';

export const BidStrategyReact = (props) => {
  const {
    i18n,
    onStrategyChange,
    keys,
    defaultSelectedKey,
    isDisabled,
  } = props;
  const options = keys.map(key => ({ key, text: i18n.getString(`BidStrategySetting_Option_${key}`), title: i18n.getString(`BidStrategySetting_Option_${key}`) }));
  return (
    <div className="form-group" key="bid-strategy-options">
      <div className="col-sm-2 control-label">
        <label>{i18n.getString('BidStrategySetting_Label_BidStrategy')}</label>
        <HelpPopup
          topic="pop_BA_CampaignCreate_Budget_BidStrategy"
          aria-label={`${i18n.getString('LearnMoreLinkText')} ${i18n.getString('BidStrategySetting_Label_BidStrategy')}`}
        />
      </div>
      <div className="col-sm-10 form-control-static">
        <span>
          {i18n.getString('BidStrategySetting_OptionQuestion')}&nbsp;
          <HelpLink class="HelpTopic" query="56786" aria-label={`Click to learn more about ${i18n.getString('BidStrategySetting_OptionQuestion')}`} role="button">
            {i18n.getString('LearnMoreLinkText')}
          </HelpLink>
        </span>
      </div>
      <Dropdown
        isDisabled={isDisabled}
        className="col-sm-4"
        options={options}
        defaultSelectedKey={defaultSelectedKey}
        onChange={(ev, item) => onStrategyChange(item)}
      />
    </div>);
};

BidStrategyReact.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onStrategyChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  defaultSelectedKey: PropTypes.string.isRequired,
};

BidStrategyReact.defaultProps = {
  isDisabled: false,
};
